import { SpavaObj, Image } from "./SpavaObj";
import { Vehicle } from "./PassControl";
import { time } from "../ladmin/utils";
import { Template } from "./Message";

export const BILL_STATUS_TEXT = {
  unsettled: "账单未结算",
  settled_unpaid: "账单未支付",
  settled_additional: "账单尚有补交费用未支付",
  paid: "账单已支付",
  finished: "账单已完成"
};

export {};
